import Choices from 'choices.js';

class FormContact {
  constructor() {
    this._init();
  }

  _init() {

    const form = document.querySelector<HTMLFormElement>('.wpcf7-form');
    if (!form) return;

    // Selects
    const selects = document.querySelectorAll('select') as NodeListOf<HTMLSelectElement>;
    if (selects) {

      selects.forEach(select => {
        new Choices(select, {
          searchEnabled: false,
          searchChoices: false,
          itemSelectText: ''
        });


      });


    }
  }
}

export const formContact = new FormContact();
